import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";
import { entityOfType } from "../../utils/system-entities";
import { SystemEntity } from "@erp/shared-types";

export const identify849EmailStep = defineStepConfig({
  type: "identify_849_email",
  name: "Identify 849 Email",
  description:
    "After the supplier is identified, decide whether its email is an 849 response. " +
    "Runs supplier-specific deterministic subject rules first, then uses the supplier's " +
    "configured context for an LLM fallback. Outputs a boolean for conditional branching " +
    "before any SD849Response is created.",
  category: "AI & Agents",
  libraryModule: "ShipAndDebit",

  inputSchema: z.object({
    inboundEmail: entityOfType(SystemEntity.INBOUND_EMAIL).describe(
      "The inbound supplier email to classify",
    ),
    customerName: z
      .string()
      .nullable()
      .describe("Supplier/customer name returned by Identify SD Customer"),
  }),

  outputSchema: z.object({
    inboundEmail: entityOfType(SystemEntity.INBOUND_EMAIL).describe(
      "Pass-through of the inbound email",
    ),
    is849: z
      .boolean()
      .describe("Whether this email should continue to 849 processing"),
    confidence: z.number().min(0).max(1),
    reason: z.string(),
    detectionMethod: z.enum(["deterministic", "llm", "none"]),
  }),

  configSchema: z.object({}),
  emits: [] as const,

  execution: {
    startToCloseTimeout: "2 minutes",
    retry: {
      maximumAttempts: 2,
    },
  },
});
